<template>
  <div v-if="shortBtn" class="button-wrapper" @click="handleClick">
    <div class="read-more">
      <img
        src="@/assets/icons/Button.svg"
        alt="button"
        class="button-img"
      />
      <a id="apply-wwu" :href="'/work-with-us'" class="button-text">
        {{ text }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,

  props: {
    text: {
      type: String,
      default: 'Apply'
    },

    btnIcon: {
      type: Boolean,
      default: true,
    },

    width: {
      type: String,
      default: '200'
    },

    shortBtn: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    handleClick() {
      this.$emit('click')
    }
  }
}
</script>

<style scoped>
.button-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.read-more {
  position: relative;
  text-align: center;
  color: black;
  width: 100%;
  max-width: 270px;
  cursor: pointer;
}

.button-img {
  width: 100%;
  height: auto;
  display: block;
}

.button-text {
  position: absolute;
  top: 35%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: black;
  font-weight: bold;
  text-decoration: none;
  font-size: 1.2rem;
  white-space: nowrap;
}

/* Responsive font size */
@media (max-width: 480px) {
  .button-text {
    font-size: 0.9rem;
  }
}
</style>
